module.exports = __webpack_public_path__ + "img/Kingsland_Seal_White.8a8c6b8e.png";